import A1 from "../assets/img/A1.png";
import A2 from "../assets/img/A2.png";
import A3 from "../assets/img/A3.png";
import A4 from "../assets/img/A4.png";
import A5 from "../assets/img/A5.png";

export const DRESS_COLORS = [
    // Tonos cálidos
    {
        label: "Terracota",
        color: "#C97B5A"
    },
    {
        label: "Borgoña",
        color: "#8B2E1A"
    },
    {
        label: "Naranja",
        color: "#D4874A"
    },
    {
        label: "Oro antiguo",
        color: "#AB8A3B"
    },
    // Tonos neutros
    {
        label: "Lino dorado",
        color: "#C9A87C"
    },
    // Azules
    {
        label: "Azul celeste",
        color: "#7397A8"
    },
];

export const AVOID_COLORS = [{
        label: "Blanco",
        color: "#FAFAFA"
    },
    {
        label: "Olive green",
        color: "#53694D"
    },
    {
        label: "Navy",
        color: "#223348"
    },
];

export const TIMELINE = [{
        time: "12:00 PM",
        icon: A1,
        label: "Recepción"
    },
    {
        time: "13:00 PM",
        icon: A2,
        label: "Ceremonia"
    },
    {
        time: "14:00 PM",
        icon: A3,
        label: "Comida"
    },
    {
        time: "15:00 PM",
        icon: A4,
        label: "Brindis"
    },
    {
        time: "16:00 PM",
        icon: A5,
        label: "Fotos y Despedida"
    },
];